import axios from 'axios';
import type { Scenario, CreateScenarioDto } from './types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

// Log API_URL once on module initialization for diagnostics
console.log('[scenario-api] API_URL:', API_URL);

const getAuthToken = (): string | null => {
  const authStorage = localStorage.getItem('auth-storage');
  if (!authStorage) return null;
  const parsed = JSON.parse(authStorage) as { state?: { token?: string } };
  return parsed.state?.token || null;
};

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const scenarioApi = {
  async listByProject(projectId: string): Promise<Scenario[]> {
    const response = await axios.get<Scenario[]>(
      `${API_URL}/scenarios/by-project/${projectId}`,
      { headers: authHeaders() }
    );
    return response.data;
  },

  async create(data: CreateScenarioDto): Promise<Scenario> {
    const response = await axios.post<Scenario>(
      `${API_URL}/scenarios`,
      data,
      { headers: authHeaders() }
    );
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await axios.delete(`${API_URL}/scenarios/${id}`, { headers: authHeaders() });
  },

  async duplicate(id: string): Promise<Scenario> {
    const response = await axios.post<Scenario>(
      `${API_URL}/scenarios/${id}/duplicate`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  },
};
